export default __webpack_public_path__ + "static/media/well_done.9da133d6.mp3";